import Skeleton from "react-loading-skeleton";
import {
  SKELETON_BASE_COLOR,
  SKELETON_HIGHLIGHT_COLOR,
} from "../../utils/constants";
import { ContainerCard } from "../cards/containerCard";
import { Icon } from "../icons/icon";

export const InvitationCardLoader = ({ count = 1 }: { count?: number }) => {
  return (
    <div className="flex flex-col gap-4">
      {Array.from({ length: count }).map((_, i) => {
        return (
          <ContainerCard
            className="!px-6 md:!px-8 !py-6 !max-w-[526px] flex flex-col gap-4"
            key={`${i}`}
          >
            <div className="flex items-center gap-2">
              <Skeleton
                width={"32px"}
                height={"32px"}
                baseColor={SKELETON_BASE_COLOR}
                highlightColor={SKELETON_HIGHLIGHT_COLOR}
                className="rounded-full"
              />

              <Icon
                svg="left-arrow"
                width={20}
                height={20}
                className="rotate-180"
              />

              <Skeleton
                width={"32px"}
                height={"32px"}
                baseColor={SKELETON_BASE_COLOR}
                highlightColor={SKELETON_HIGHLIGHT_COLOR}
                className="rounded-full"
              />
            </div>

            <Skeleton
              width={"100%"}
              height={"24px"}
              baseColor={SKELETON_BASE_COLOR}
              highlightColor={SKELETON_HIGHLIGHT_COLOR}
              className="rounded"
            />

            <Skeleton
              width={"40%"}
              height={"24px"}
              baseColor={SKELETON_BASE_COLOR}
              highlightColor={SKELETON_HIGHLIGHT_COLOR}
              className="rounded-"
            />
          </ContainerCard>
        );
      })}
    </div>
  );
};
